import {Col, Row} from "antd";
import React, {useState} from "react";
import {CourierWalletSettings} from "./courierWalletSettings/CourierWalletSettings";
import {CourierWallet} from "./courierWallet/CourierWallet";

export const CourierWalletTab = ({
    courier,
    courierLoading = true,
    isTabActive = false,
    reloadCourier = () => {}
}) => {
    const [reloadWallet, setReloadWallet] = useState(false);

    const reload = async () => {
        reloadCourier();
        setTimeout(() => {
            setReloadWallet(!reloadWallet);
        }, 1000);
    };

    return (
        <div>
            <Row gutter={[20, 20]}>
                {!courier?.isWalletActive && !courierLoading && (
                    <Col xs={24} sm={24} md={12} lg={8} xl={8} span={5}>
                        <CourierWalletSettings
                            courier={courier}
                            courierLoading={courierLoading}
                            reloadCourier={reload}
                        />
                    </Col>
                )}
                {courier?.isWalletActive && !courierLoading && (
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} span={24}>
                        <CourierWallet
                            courier={courier}
                            courierLoading={courierLoading}
                            canRender={isTabActive}
                            reloadWallet={reloadWallet}
                        />
                    </Col>
                )}
            </Row>
        </div>
    );
};
